import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import FeedbackModal from '../../modals/FeedbackModal';
import { Hourglass } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { getSuppliers } from '../../../services/api'; // Função para buscar fornecedores
import IntegrarFornecedoresModal from '../../modals/integrarfornecedores'; // Modal para integração
import DetalhesSupplier from '../../modals/detalhessupplier'; // Nova modal de detalhes do fornecedor

const ConsultarFornecedor = () => {
    const [fornecedores, setFornecedores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [feedbackStatus, setFeedbackStatus] = useState(''); // 'loading', 'success', 'error'
    const [feedbackMessage, setFeedbackMessage] = useState('');

    // Estados para integração de produtos com o fornecedor
    const [integrationModalOpen, setIntegrationModalOpen] = useState(false);
    // Estados para exibir detalhes do fornecedor
    const [detailsModalOpen, setDetailsModalOpen] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(null);

    useEffect(() => {
        const fetchFornecedores = async () => {
            setLoading(true);
            setFeedbackStatus('loading');
            setFeedbackMessage('Loading suppliers...');
            setFeedbackVisible(true);
            try {
                const response = await getSuppliers();
                setFornecedores(response.data);
                setFeedbackStatus('success');
                setFeedbackMessage('Suppliers loaded successfully!');
            } catch (error) {
                console.error('Error loading suppliers:', error);
                setFeedbackStatus('error');
                setFeedbackMessage('Error loading suppliers.');
            }
            setLoading(false);
            // Fecha o modal de feedback após 1.5 segundos
            setTimeout(() => {
                setFeedbackVisible(false);
            }, 1500);
        };

        fetchFornecedores();
    }, []);

    const header = (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span className="p-input-icon-right">
                <InputText 
                    type="search" 
                    onInput={(e) => setGlobalFilter(e.target.value)} 
                    placeholder="Search suppliers" 
                    size="50" 
                />
                <i className="pi pi-search" style={{ right: '10px' }} />
            </span>
        </div>
    );

    // Abre a modal de detalhes do fornecedor
    const handleOpenDetails = (supplier) => {
        setSelectedSupplier(supplier);
        setDetailsModalOpen(true);
    };

    const closeDetailsModal = () => {
        setDetailsModalOpen(false);
        setSelectedSupplier(null);
    };

    const handleDelete = (supplier) => {
        console.log("Delete supplier:", supplier);
        // Implemente a lógica para excluir o supplier
    };

    // Função para abrir a modal de integração
    const handleIntegrate = (supplier) => {
        setSelectedSupplier(supplier);
        setIntegrationModalOpen(true);
    };

    const closeIntegrationModal = () => {
        setIntegrationModalOpen(false);
        setSelectedSupplier(null);
    };

    // Novo template de ações, com botões de detalhes, delete e integração
    const actionBodyTemplate = (rowData) => {
        return (
            <div>
                <Button 
                    icon="pi pi-info-circle" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleOpenDetails(rowData)}
                />
                <Button 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-button-text p-button-danger" 
                    onClick={() => handleDelete(rowData)}
                />
                <Button 
                    icon="pi pi-link" 
                    className="p-button-rounded p-button-text" 
                    onClick={() => handleIntegrate(rowData)}
                />
            </div>
        );
    };

    return (
        <Card title="Consult Suppliers">
            <DataTable 
                value={fornecedores} 
                paginator 
                rows={10} 
                header={header} 
                globalFilter={globalFilter} 
                loading={loading}
                responsiveLayout="scroll"
                emptyMessage="No suppliers found."
            >
                <Column field="name" header="Name" sortable />
                <Column field="phone" header="Phone" sortable />
                <Column field="email" header="Email" sortable />
                <Column body={actionBodyTemplate} header="Actions" exportable={false} style={{ minWidth: '8rem' }} />
            </DataTable>

            <FeedbackModal visible={feedbackVisible}>
                {feedbackStatus === 'loading' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Hourglass height="50" width="50" color="#000" ariaLabel="loading" />
                        <p>{feedbackMessage}</p>
                    </div>
                )}
                {feedbackStatus === 'success' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <CheckCircleIcon style={{ fontSize: 50, color: 'green' }} />
                        <p>{feedbackMessage}</p>
                    </div>
                )}
                {feedbackStatus === 'error' && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <p style={{ color: 'red' }}>{feedbackMessage}</p>
                    </div>
                )}
            </FeedbackModal>

            {/* Modal para integração de produtos */}
            {selectedSupplier && integrationModalOpen && (
                <IntegrarFornecedoresModal 
                    open={integrationModalOpen} 
                    onClose={closeIntegrationModal} 
                    supplier={selectedSupplier}
                />
            )}

            {/* Modal para detalhes do fornecedor */}
            {selectedSupplier && detailsModalOpen && (
                <DetalhesSupplier 
                    open={detailsModalOpen}
                    onClose={closeDetailsModal}
                    supplier={selectedSupplier}
                />
            )}
        </Card>
    );
};

export default ConsultarFornecedor;
